module.exports = __webpack_public_path__ + "static/media/90.74dd2bae.jpg";